// |--------------------------------------------------------------------------
// |Password パスワード
// |--------------------------------------------------------------------------
// |
// | ここではパスワードのapiを例として記述しています。
// | パスワードで使用するapiを全て記述します。
// | このapiを親のjs（functionApi.js）でimportして使用します。

/* ---------------------------------------------------------------------------
  パスワード忘れ
---------------------------------------------------------------------------- */
export const send = async data => {
	return await axios.post(`/api/password/send`, data);
};
/* ---------------------------------------------------------------------------
  パスワード再設定
---------------------------------------------------------------------------- */
export const getToken = async data => {
	return await axios.get(`/api/password/reset/${data}`);
};

export const reset = async data => {
	return await axios.post(`/api/password/reset`, data);
};
